export function resolveCssColor(color: string): string {
  const trimmed = color.trim();

  const varMatch = trimmed.match(/^var\(\s*(--[^,)]+)\s*(?:,\s*(.+))?\)$/);
  if (!varMatch) {
    return trimmed;
  }

  const [, varName, fallback] = varMatch;

  if (typeof window !== 'undefined' && typeof getComputedStyle === 'function') {
    const value = getComputedStyle(document.documentElement)
      .getPropertyValue(varName)
      .trim();
    if (value) {
      return resolveCssColor(value);
    }
  }

  return fallback ? resolveCssColor(fallback.trim()) : trimmed;
}

function parseRgb(color: string): [number, number, number] | null {
  let value = color.trim();

  if (value.startsWith('#')) {
    let hex = value.slice(1);
    if (hex.length === 3) {
      hex = hex
        .split('')
        .map((c) => c + c)
        .join('');
    }
    if (hex.length < 6) {
      return null;
    }
    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);
    if ([r, g, b].some(Number.isNaN)) {
      return null;
    }
    return [r, g, b];
  }

  const rgbMatch = value.match(
    /rgba?\(\s*([\d.]+)[\s,]+([\d.]+)[\s,]+([\d.]+)/i
  );
  if (rgbMatch) {
    return [
      Math.round(Number(rgbMatch[1])),
      Math.round(Number(rgbMatch[2])),
      Math.round(Number(rgbMatch[3]))
    ];
  }

  return null;
}

export function lightenColor(color: string, amount = 0.2) {
  const resolved = resolveCssColor(color);
  const rgb = parseRgb(resolved);

  if (!rgb) {
    return resolved;
  }

  let [r, g, b] = rgb;

  r = Math.round(r + (255 - r) * amount);
  g = Math.round(g + (255 - g) * amount);
  b = Math.round(b + (255 - b) * amount);

  return (
    '#' +
    r.toString(16).padStart(2, '0') +
    g.toString(16).padStart(2, '0') +
    b.toString(16).padStart(2, '0')
  );
}
